<script lang="ts">
  import type { DirectoryResponse } from "@shared/types";

  import { Button, ErrorNote, Loading } from "../components/ui";
  import { httpError } from "../lib/pb";
  import { link, location, navigate } from "../lib/router.svelte";
  import { useAsync } from "../lib/useAsync.svelte";
  import Directory from "./Directory.svelte";

  const loaded = useAsync(async () => {
    const response = await fetch("/api/directorio");
    if (response.status === 404) {
      if (location.pathname === "/") navigate("/admin", { replace: true });
      return null;
    }
    const data = await response.json().catch(() => null);
    if (!response.ok) throw httpError(response, data);
    if (!data || !Array.isArray(data.apps)) {
      throw new Error("No se recibió la lista de aplicaciones. Vuelve a intentarlo.");
    }
    return data as DirectoryResponse;
  });
</script>

{#if loaded.loading || (!loaded.data && !loaded.error)}
  <Loading label="Cargando aplicaciones" />
{:else if loaded.data}
  <Directory apps={loaded.data.apps} />
{:else}
  <main class="error-directory-root">
    <h1>No se pudo cargar el directorio</h1>
    <ErrorNote message={loaded.error} />
    <Button buttonClass="btn-directory-retry" onclick={() => void loaded.reload()}>
      Reintentar
    </Button>
    <a class="link-directory-panel link" href="/admin" use:link>Panel de administración</a>
  </main>
{/if}

<style>
  .error-directory-root {
    display: grid;
    justify-items: start;
    gap: var(--sp-16);
    max-width: calc(var(--container) / 2);
    margin-inline: auto;
    padding: var(--sp-40) var(--sp-24);
    & h1 {
      font-size: var(--type-2xl);
    }
  }
</style>
